import { classes, selectors } from './init';

export const hideAnchorNav = (el) => {
	el.classList.remove(classes.show);
	el.classList.add(classes.hide);
	disableActiveNavItem();
};

export const showAnchorNav = (el) => {
	el.classList.remove(classes.hide);
	el.classList.add(classes.show);
};

export const disableActiveNavItem = () => {
	let activeItem = document.querySelector(selectors.activeItem);
	activeItem && activeItem.classList.remove(classes.active);
};

export const enableNavItem = (item) => {
	// Continue if current nav item is not already active
	if (!item.classList.contains('active')) {
		// Remove active state from other possible item
		disableActiveNavItem();

		// Add active state to current nav item
		item.classList.add(classes.active);
	}
};

export const setAnchorNavItemVisibility = (container) => {
	container.querySelectorAll(selectors.item).forEach((el) => {
		const section = document.querySelector(`#${el.getAttribute('data-target')}`);
		el.hidden = !section.checkVisibility();
	});
};

export const getAnchors = (container) => {
	const anchors = [];

	container.querySelectorAll(selectors.item).forEach((el) => {
		const section = document.querySelector(`#${el.getAttribute('data-target')}`);
		section && anchors.push(section);
	});

	return anchors;
};
